setTimeout(() => {
  function handleButtonClick(e) {
    e.preventDefault();
    const $button = $(this);
    let oldText = $(this).text();
    $button.css({ "pointer-events": "none", opacity: "0.6" });
    $button.text("Loading ...");
    setTimeout(() => {
      $button.css({ "pointer-events": "unset", opacity: "1" });
      $button.text(oldText);
      BSS_B2B.customTriggerCheckoutBtn($button);
    }, 2000);
  }

  $(document).on(
    "click dblclick",
    'button[name="checkout"]',
    handleButtonClick
  );
}, 500);

BSS_B2B.customTriggerCheckoutBtn = function (checkoutBtn) {
  window.location.href = "/checkout";
};
